module.exports = __webpack_public_path__ + "img/ae48906.jpg";